import { CognitoUserSession, CognitoAccessToken, CognitoIdToken, CognitoRefreshToken, CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import SessionService from '../services/SessionService';

const poolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID,
  ClientId: process.env.REACT_APP_CLIENT_ID
};



export const userPool = new CognitoUserPool(poolData);


export const signIn = (username, password) => {

  return new Promise((resolve, reject) => {
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });

    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool
    });

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        resolve(result);
      },
      onFailure: (err) => {
        alert('Incorrect credentials. Please try again.');
        reject(err);
      },
      totpRequired: (codeDeliveryDetails) => {
        resolve({ userConfirmationNecessary: true, cognitoUser });
      }
    });
  });
};

export const isAuthenticated = () => {
  return new Promise((resolve, reject) => {
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err);
        } else {
          const accessToken = session.getAccessToken().getJwtToken();
          const idToken = session.getIdToken().getJwtToken();
          const refreshToken = session.getRefreshToken().getToken();
          // Store tokens in localStorage
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('idToken', idToken);
          localStorage.setItem('refreshToken', refreshToken);

          resolve(session.isValid());
        }
      });
    } else {
      resolve(false);
    }
  });
};

export const setupTOTP = (cognitoUser) => {
  return new Promise((resolve, reject) => {
    cognitoUser.associateSoftwareToken({
      associateSecretCode: (secretCode) => {
        resolve(secretCode);
      },
      onFailure: (err) => {
        reject(err);
      }
    });
  });
};



export const verifyTOTP = (cognitoUser, totpCode) => {
  return new Promise((resolve, reject) => {
    // Retrieve session from localStorage
    const sessionData = {
      IdToken: new CognitoIdToken({ IdToken: localStorage.getItem('idToken') }),
      AccessToken: new CognitoAccessToken({ AccessToken: localStorage.getItem('accessToken') }),
      RefreshToken: new CognitoRefreshToken({ RefreshToken: localStorage.getItem('refreshToken') })
    };

    const cachedSession = new CognitoUserSession(sessionData);
    cognitoUser.setSignInUserSession(cachedSession);

    // Verify the TOTP code
    cognitoUser.verifySoftwareToken(totpCode, 'My TOTP device', {
      onSuccess: (result) => {
        // After successful verification, set TOTP as the preferred MFA method
        cognitoUser.setUserMfaPreference(null, { PreferredMfa: true, Enabled: true }, (err, result) => {
          if (err) {
            reject(err);
          } else {
            // Get the current session to update the tokens
            cognitoUser.getSession((err, session) => {
              if (err) {
                reject(err);
              } else {
                resolve(result);
              }
            });
          }
        });
      },
      onFailure: (err) => {
        reject(err);
      }
    });
  });
};


export const signInWithTOTP = (cognitoUser, totpCode) => {
  // const navigate = useNavigate();
  return new Promise((resolve, reject) => {
    cognitoUser.sendMFACode(
      totpCode,
      {
        onSuccess: async function (session) {
          localStorage.setItem('authenticated', true);
          SessionService.setCompanyName(session.getIdToken().payload['custom:company']);
          localStorage.setItem('companyName', session.getIdToken().payload['custom:company']);
          localStorage.setItem('masterCompanyName', session.getIdToken().payload['custom:company']);
          localStorage.setItem('user_id', session.getIdToken().payload['sub']);
          SessionService.setCognitoGroups(session.getIdToken().payload['cognito:groups']);
          session.getIdToken().payload['cognito:groups'].forEach(element => {
            if (!element.includes('_module')) {
              localStorage.setItem('user_role', element);
            }
          });
          SessionService.setAuthenticated(true);
          resolve(session);
        },
        onFailure: function (err) {
          alert('Incorrect code entered, Please try again');
          reject(err);
        }
      },
      'SOFTWARE_TOKEN_MFA'
    );
  });
};


// Function to manually restore session from tokens
export const restoreSession = (cognitoUser) => {
  const accessToken = new CognitoAccessToken({
    AccessToken: localStorage.getItem('accessToken')
  });
  const idToken = new CognitoIdToken({
    IdToken: localStorage.getItem('idToken')
  });
  const refreshToken = new CognitoRefreshToken({
    RefreshToken: localStorage.getItem('refreshToken')
  });

  const sessionData = {
    IdToken: idToken,
    AccessToken: accessToken,
    RefreshToken: refreshToken,
  };

  const userSession = new CognitoUserSession(sessionData);
  cognitoUser.setSignInUserSession(userSession);
};

// Function to refresh session if the tokens have expired
export const refreshSession = (cognitoUser) => {
  return new Promise((resolve, reject) => {
    const refreshToken = new CognitoRefreshToken({
      RefreshToken: localStorage.getItem('refreshToken')
    });

    cognitoUser.refreshSession(refreshToken, (err, session) => {
      if (err) {
        reject(err);
      } else {
        localStorage.setItem('accessToken', session.getAccessToken().getJwtToken());
        localStorage.setItem('idToken', session.getIdToken().getJwtToken());
        resolve(session);
      }
    });
  });
};